import React from 'react';
import { Box } from 'reflexbox';
import {
  Columns,
  StyledFormContainer,
  StyledHidingContainer,
  StyledPaperContainer,
  StyledSectionHeader,
  StyledSectionTitle,
  StyledSwitch,
} from '../../PlusWebsiteEditor.styles';
import ImageUploader from '../../components/ImageUploader/ImageUploader';
import { InputField } from '../../../../healtheraComponents';
import { AboutUs, WebsiteConfiguration } from '../../types/websiteConfiguration';
import { SectionHandlers, SetObjectFieldValue } from '../../types/handlers';

type Props = WebsiteConfiguration['about_us'] &
  SectionHandlers & {
    onChange: SetObjectFieldValue<AboutUs>;
  };

const AboutUsSection = ({ enabled, title, description, image, image_url, onChange, onBlur, getError }: Props) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.name, e.target.value);

  return (
    <StyledPaperContainer>
      <StyledSectionHeader>
        <StyledSectionTitle>About Us</StyledSectionTitle>
        <StyledSwitch onChange={(_: any, checked: boolean) => onChange('enabled', checked, true)} label="Show section" checked={!!enabled} value={!!enabled} />
      </StyledSectionHeader>
      <StyledHidingContainer>
        <Columns>
          <StyledFormContainer>
            <Box>
              <InputField onBlur={onBlur} helperText={getError('title')} name="title" onChange={handleInputChange} margintop="20px" label="Title" value={title} />
              <InputField onBlur={onBlur} helperText={getError('description')} name="description" onChange={handleInputChange} multiline margintop="20px" label="Description" value={description} />
            </Box>
          </StyledFormContainer>
          <ImageUploader helperText={getError('image')} title="Banner Image" url={image || image_url || ''} onChange={(base64: string) => onChange('image', base64, true)} />
        </Columns>
      </StyledHidingContainer>
    </StyledPaperContainer>
  );
};

export default AboutUsSection;
